<div class="mt-2" *ngIf="links && links.length > 0">
  <div class="list-group list-group-flush border rounded">
    <div class="list-group-item py-1 px-2 text-white" style="font-size: 0.7rem; font-weight: 600; letter-spacing: 0.05em;  background-color: var(--bs-secondary);">
      <fa-icon [icon]="faLink" class="me-1"></fa-icon>Linked Cases
    </div>
    <a *ngFor="let link of links"
       class="list-group-item list-group-item-action d-flex justify-content-between py-1 px-2 small"
       style="cursor: pointer;"
       (click)="gotoCase(link.id)">
      <span>{{ link.type.caseTypeName }}</span>
      <span class="text-muted">{{ link.instructedDate | date:'dd/MM/yyyy' }}</span>
    </a>
  </div>
</div>